import angular from 'angular';

import '../../factory/authentication';

angular.module("merchant.application.main").directive("merchant.application.main.directive.permissions", [
    "merchant.application.main.factory.authentication",
    function(Authentication) {

        // Given a list of comma separated permission strings
        // determine if the user is allowed access to the element
        // the element will become disabled if they don't have access
        // Example usage
        //    merchant.application.main.directive.permissions permissions="EDIT_SHIPPED_STATUS, EDIT_PROCESS_REFUNDS"
        // this means that if the user has either the EDIT_SHIPPED_STATUS or EDIT_PROCESS_REFUNDS
        // permission, they will be able to access the element
        //
        // !!! NOTE !!!
        // This directive won't work on an element with an ng-if on it.
        // So you need to wrap the element with a containing div/span which has
        // the ng-if on it instead

        var expose = {};
        expose.restrict = "A";
        expose.scope = {};

        expose.link = function(scope, element, attributes) {

            var permissions = [];
            if (attributes.permissions)
                permissions = attributes.permissions.split(" ").join("").split(",");

            scope.checkPermissions = function() {
                if (permissions.length != 0 && ! Authentication.hasAnyPermissions(permissions)) {
                    if (attributes.hideWithoutPermissions === "true") {
                        element.addClass("ng-hide");
                    }
                    element.addClass("disabled");
                    element.prop("disabled", true);
                    element.on("click", function(ev) {
                        ev.preventDefault();
                    });
                }
            };

            var channels = [];
            if (attributes.channels)
                channels = attributes.channels.split(" ");
            scope.checkChannels = function () {
                if (channels.includes("ONLINE_CARD")) {
                    return;
                }
                if (channels.length != 0 && ! Authentication.hasAnyChannel(channels)) {

                    if (attributes.hideWithoutPermissions === "true") {
                        element.addClass("ng-hide");
                    }
                    element.addClass("disabled");
                    element.prop("disabled", true);
                    element.on("click", function(ev) {
                        ev.preventDefault();
                    });
                }
            };

            scope.$watch(Authentication.loggedIn, function() {
                scope.checkPermissions();
                scope.checkChannels();
            });

            attributes.$observe("disabled", function(disabled) {
                if (! disabled) {
                    // ng-disabled can override any previously set permissions
                    // so we check the permissions again after it's finished
                    scope.checkPermissions();
                    scope.checkChannels();
                }
            });

        };

        return expose;
    }
]);
